var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPromotions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_500_3319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 38.2353V34.7059H29.4L37.5 24.1176L29.4 13.5294H9.6V22.3529H6V13.5294C6 12.5588 6.3525 11.7279 7.0575 11.0368C7.7625 10.3456 8.61 10 9.6 10H29.4C29.97 10 30.51 10.125 31.02 10.375C31.53 10.625 31.95 10.9706 32.28 11.4118L42 24.1176L32.28 36.8235C31.95 37.2647 31.53 37.6103 31.02 37.8603C30.51 38.1103 29.97 38.2353 29.4 38.2353H24ZM11.4 40V34.7059H6V31.1765H11.4V25.8824H15V31.1765H20.4V34.7059H15V40H11.4Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_500_3319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPromotions);
export default __webpack_public_path__ + "static/media/NoPromotions.9f754390412cda4f78ec8a0b8e897ecb.svg";
export { ForwardRef as ReactComponent };